import { SwiperSlide } from 'swiper/react';

import { AspectRatioImage } from '@/components/AspectRatioImage/AspectRatioImage';
import type { ContentfulAsset } from '@/graphql/contentful/api';

import * as S from '../MediaWrapper.styles';

export interface CardImageProps {
  _focalPoint?: {
    focalPoint: { x: number; y: number };
  };
  _image: ContentfulAsset[];
  alt?: string | null;
  aspectRatioData: { x: number; y: number };
  className?: string;
  loaderProps?: { height: number };
  eagerPoster?: boolean;
  mediaWrapperType?: string;
  preload?: boolean;
  setLoadingState?: (state: string) => void;
  sizes?: string;
  useLoader?: boolean;
  width?: string;
  widths?: number[];
}

export const MobileImage = (props: CardImageProps) => {
  const {
    _focalPoint,
    _image,
    alt,
    aspectRatioData,
    className,
    eagerPoster,
    loaderProps,
    mediaWrapperType,
    preload,
    setLoadingState,
    sizes,
    useLoader,
    width,
    widths,
  } = props;

  const OptimizedImage = (img: ContentfulAsset, isPoster: boolean) => {
    return (
      <AspectRatioImage
        alt={alt ?? ''}
        aspectRatio={aspectRatioData}
        className={className ?? 'default'}
        data-test-id='MediaWrapperAspectRatioImage'
        focalPoint={{
          x: _focalPoint?.focalPoint?.x as number,
          y: _focalPoint?.focalPoint?.y as number,
        }}
        loaderProps={loaderProps}
        loading={isPoster && (preload || eagerPoster) ? 'eager' : 'lazy'}
        priority={Boolean(preload && isPoster)}
        mediaWrapperType={mediaWrapperType}
        originalImageDimensions={{
          x: img.width as number,
          y: img.height as number,
        }}
        setLoadingState={(state: string) =>
          setLoadingState && setLoadingState(state)
        }
        showFallbackPlaceholder
        sizes={sizes ?? ''}
        src={img.url as string}
        useLoader={useLoader ?? false}
        width={width ?? '100%'}
        widths={widths}
      />
    );
  };

  return (
    <S.MobileImageWrapper
      data-testid='mobileCardImageBox'
      {...(_image.length < 2 && { as: 'div' })}
    >
      {_image.length > 1
        ? _image.map((slideImg, i) => {
            return (
              slideImg && (
                <SwiperSlide
                  key={slideImg.sys.id}
                  data-testid={`CardSwiperSlide-${i}`}
                >
                  {OptimizedImage(slideImg as ContentfulAsset, i === 0)}
                </SwiperSlide>
              )
            );
          })
        : OptimizedImage(_image[0], true)}
    </S.MobileImageWrapper>
  );
};
